{
  "Automatic ({language})": "Automático ({language})",
  "Language": "Idioma",
  "Cancel": "Cancelar",
  "OK": "OK",
  "Ok": "OK",
  "Okay": "OK",
  "Yes": "Sim",
  "No": "Não",
  "Save": "Salvar",
  "Saved": "Salvo",
  "Saving...": "Salvando...",
  "Saving…": "Salvando…",
  "Delete": "Excluir",
  "Remove": "Remover",
  "Edit": "Editar",
  "Change": "Alterar",
  "Close": "Fechar",
  "Done": "Concluído",
  "Back": "Voltar",
  "Next": "Avançar",
  "Continue": "Continuar",
  "Skip": "Pular",
  "Retry": "Tentar novamente",
  "Try again": "Tentar novamente",
  "Please try again.": "Tente novamente.",
  "Please try again": "Tente novamente",
  "Something went wrong": "Algo deu errado",
  "Something went wrong. Please try again.": "Algo deu errado. Tente novamente.",
  "Error": "Erro",
  "Loading...": "Carregando...",
  "Loading…": "Carregando…",
  "Share": "Compartilhar",
  "Copy": "Copiar",
  "Copy link": "Copiar link",
  "Copied": "Copiado",
  "Copied!": "Copiado!",
  "Link copied": "Link copiado",
  "Open": "Abrir",
  "Restore": "Restaurar",
  "Learn more": "Saiba mais",
  "More": "Mais",
  "Help": "Ajuda",
  "Settings": "Configurações",
  "Open Settings": "Abrir configurações",
  "Profile": "Perfil",
  "Email": "E-mail",
  "Password": "Senha",
  "Name": "Nome",
  "Title": "Título",
  "Location": "Local",
  "Date and time": "Data e hora",
  "Privacy": "Privacidade",
  "Embed": "Embed",
  "Branding": "Marca",
  "Logo": "Logotipo",
  "Guestbook": "Livro de visitas",
  "Fundraising": "Arrecadação",
  "Pricing": "Preços",
  "Plans": "Planos",
  "EventLive Plans": "Planos do EventLive",
  "My Events": "Meus eventos",
  "Event link": "Link do evento",
  "Event title": "Título do evento",
  "Go Live": "Transmitir ao vivo",
  "Watch Live": "Assistir ao vivo",
  "Live only": "Só ao vivo",
  "Start free test": "Iniciar teste grátis",
  "Free test": "Teste grátis",
  "Unlock event": "Desbloquear evento",
  "Unlock": "Desbloquear",
  "Sell Tickets": "Vender ingressos",
  "Video Wall": "Mural de vídeos",
  "Manage Video": "Gerenciar vídeo",
  "Upload video": "Enviar vídeo",
  "What's new": "Novidades",
  "What's New": "Novidades",
  "Camera": "Câmera",
  "Required": "Obrigatório",
  "Terms": "Termos",
  "Monthly": "Mensal",
  "Unlimited": "Ilimitado",
  "Not found": "Não encontrado",
  "Not signed in": "Você não entrou na sua conta",
  "Please sign in again.": "Entre na sua conta novamente.",
  "Too many requests. Please wait a moment and try again.": "Muitas solicitações. Aguarde um momento e tente novamente.",
  "Welcome to EventLive": "Boas-vindas ao EventLive",
  "Today": "Hoje",
  "Tomorrow": "Amanhã",
  "Yesterday": "Ontem",
  "MMM D, YYYY": "D [de] MMM [de] YYYY",
  "MMM D": "D [de] MMM",
  "h:mm A": "HH:mm",
  "h:mm a": "HH:mm",
  "Test Event": "Evento de teste"
}
